import { useSupabaseAuth } from '../auth/simplified/SupabaseAuthContext';

/**
 * Custom hook to access Auth context
 * This now uses the simplified auth context directly
 * @returns Supabase Auth context value
 */
export const useAuth = () => {
  return useSupabaseAuth();
};

// Export types from simplified SupabaseAuthContext
export type { UserProfile } from '../auth/simplified/SupabaseAuthContext';